import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useSeo } from "@/lib/useSeo";
import { getNews } from "@/lib/db";

function formatDate(d) {
  try {
    return new Date(d).toLocaleDateString("el-GR", { day: "2-digit", month: "long", year: "numeric" });
  } catch {
    return d;
  }
}

export default function NewsDetail() {
  const { id } = useParams();
  const [n, setN] = useState(null);
  const [err, setErr] = useState(false);
  useSeo({ title: n?.title, description: n?.excerpt });

  useEffect(() => {
    getNews(id).then((d) => setN(d)).catch(() => setErr(true));
  }, [id]);

  if (err) {
    return (
      <div className="club-container py-40 text-center">
        <p className="font-heading text-2xl text-white">Το άρθρο δεν βρέθηκε</p>
        <Link to="/" className="mt-4 inline-block text-gold hover:underline">Επιστροφή στην Αρχική</Link>
      </div>
    );
  }
  if (!n) return <div className="club-container py-40 text-center text-ice">Φόρτωση...</div>;

  return (
    <article data-testid="news-detail">
      <section className="relative flex h-[52vh] min-h-[360px] items-end overflow-hidden">
        <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: `url(${n.image})` }} />
        <div className="absolute inset-0 bg-gradient-to-t from-navy via-navy/80 to-navy/40" />
        <div className="club-container relative z-10 pb-12">
          <p className="font-display text-sm font-600 uppercase tracking-[0.3em] text-gold">{formatDate(n.date)}</p>
          <h1 className="font-heading mt-2 max-w-4xl text-4xl font-900 uppercase leading-tight tracking-tight text-white sm:text-6xl">
            {n.title}
          </h1>
        </div>
      </section>

      <section className="club-container max-w-3xl py-14">
        <Link to="/" className="mb-8 inline-flex items-center gap-2 font-display font-700 uppercase tracking-wide text-gold hover:underline">
          <ArrowLeft size={18} /> Πίσω
        </Link>
        <p className="mb-6 text-xl font-500 leading-relaxed text-ice">{n.excerpt}</p>
        <div className="whitespace-pre-wrap text-lg leading-relaxed text-ice/80">{n.content}</div>
      </section>
    </article>
  );
}
